import { Autoplay, Controller, EffectFade, Parallax, Navigation, Pagination, Swiper, FreeMode } from 'swiper'
// import { SwiperSlide } from 'swiper/react'
Swiper.use([Autoplay, Controller, EffectFade, Parallax, Navigation, Pagination, FreeMode]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-post')) {
  page()
}

function page() {
  //  ###    ###  ##   ##
  //  ## #  # ##  ##   ##
  //  ##  ##  ##  ##   ##
  //  ##      ##   ## ##
  //  ##      ##    ###

  if (document.getElementById('postMv')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars

    const sliderName = 'postMv'
    const slideItem = document.getElementById(sliderName)

    const postMvSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（postMvSwiper.init()で初期化）
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      // loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
      preloadImages: false, // スライド内の画像を読み終えてから開始
      touchRatio: 0.3, // タッチスワイプ感度（0でタッチスワイプ無効）

      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
        renderBullet: function (index, className) {
          // bulletsの描画内容を改変

          const targetImage = slideItem.querySelector('.swiper-slide:nth-child(' + (index + 1) + ') img').outerHTML

          return '<div class="' + className + '">' + targetImage + '</div>'
        },
      },

      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
    })
  }
}
